import Switch from "@material-ui/core/Switch";
import withStyles from "@material-ui/core/styles/withStyles";

const GreenSwitch = withStyles({
    switchBase: {
        color: "#B5B5B5",
        '&$checked': {
            color: "#FFFFFF",
        },
        '&$checked + $track': {
            backgroundColor: "#7BAC16",
            opacity: 1,
        },
        '&$disabled': {
            color: "#E0E0E0 !important",
        },
        '&$disabled + $track': {
            backgroundColor: "#F5F5F5 !important",
            opacity: 0.5,
        },
        '&$checked$disabled': {
            color: "#E0E0E0 !important",
        },
        '&$checked$disabled + $track': {
            backgroundColor: "#E0E0E0 !important",
            opacity: 0.5,
        },
    },
    checked: {},
    disabled: {},
    track: {
        backgroundColor: "#B5B5B5",
    },
})(Switch);

export default GreenSwitch;

